import React, { useState } from 'react'
import styled from 'styled-components/macro'
import { Link } from 'react-router-dom'

import { Hero } from '../Hero'
import Container from '../../atoms/Container'
import { Title, HeroTitle } from '../../atoms/Typography'
import { Button } from '../../atoms/Button'
import Logo from '../../../assets/icons/Logo'
import HeroImg from '../../../assets/images/HeroImage.jpg'
import iPhones from '../../../assets/images/LandingIPhones.png'
import Hamburger from '../../atoms/Hamburger'

// TODO controllare se conviene parametrizzare l'Header normale

export default function LandingHeader() {
  const [sideMenuVisible, setSideMenuVisible] = useState(false)
  return (
    <Hero image={HeroImg} grey style={{ paddingBottom: 0 }}>
      <Nav>
        <LinkLogo to="/">
          <LogoSvg>
            <Logo />
          </LogoSvg>
          <LogoTitle as="" font="AmpleAlt,sans-serif" weight="400">
            smart gym
          </LogoTitle>
        </LinkLogo>

        <RightNav>
          <Button
            as={Link}
            to="/accedi"
            textColor="#fff"
            borderColor="#fff"
            backColor="transparent"
            ghost
          >
            login
          </Button>
          <Button as={Link} to="/iscriviti">
            iscriviti
          </Button>
        </RightNav>

        {sideMenuVisible && (
          <SideNav>
            <Button as={Link} to="/accedi">
              login
            </Button>
            <Button as={Link} to="/iscriviti">
              iscriviti
            </Button>
          </SideNav>
        )}
        <Hamburger onClick={() => setSideMenuVisible((v) => !v)} />
      </Nav>
      <SContainer centered>
        <TextSection>
          <HeroTitle
            as="h1"
            size="88px"
            font="'AmpleAlt', Arial, Helvetica, sans-serif"
            weight="400"
          >
            smart gym
          </HeroTitle>
          <Title as="h2" size="40px" color="#fafafa" weight="400">
            il coworking del fitness a Bologna.
          </Title>
          <p>
            In pochi semplici passi potrai scegliere la sala più comoda,
            acquistare e prenotare le tue sessioni nella tua palestra personale.
          </p>
          <Button as={Link} to="/iscriviti" size="22px">
            Iscriviti subito
          </Button>
        </TextSection>
        <Figure>
          <img src={iPhones} alt="smart gym app su iphone" />
        </Figure>
      </SContainer>
    </Hero>
  )
}

const Figure = styled.figure`
  width: 45%;
  overflow: hidden;
  margin-top: 60px;

  img {
    vertical-align: top;
    width: 100%;
  }
  @media screen and (max-width: 1023px) {
    display: none;
  }
`

const SContainer = styled(Container)`
  position: relative;
  display: flex;
  justify-content: space-between;
`

const TextSection = styled.article`
  max-width: 500px;
  font-family: 'Montserrat', Arial, Helvetica, sans-serif;
  font-size: 16px;

  > h1 {
    margin-bottom: 0;
  }

  > a {
    display: inline-block;
    margin-top: 35px;
    padding: 11px 34px;
  }
  @media screen and (max-width: 1023px) {
    padding-bottom: 32px;
    > h2 {
      line-height: 1.1;
      margin-bottom: 16px;
    }
    > a {
      font-size: 18px;
    }
  }
  @media screen and (min-width: 1024px) {
    padding-top: 80px;
    font-size: 22px;
    > h1 {
      margin-bottom: -10px;
    }
    > a {
      padding: 14px 34px;
    }
  }
`

const Nav = styled.nav`
  display: flex;
  position: absolute;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;

  z-index: 1;
  @media screen and (max-width: 1023px) {
    padding: 20px;
    background-color: #fff;
  }

  @media screen and (min-width: 1024px) {
    margin: 0 auto 65px;
    justify-content: space-between;
    width: 100%;
    max-width: 1160px;
    padding: 0 20px;
    position: relative;
  }
`

const RightNav = styled.div`
  > a:first-child {
    margin-right: 20px;
  }

  > a {
    align-self: center;
  }

  @media screen and (max-width: 1023px) {
    display: none;
  }
  @media screen and (min-width: 1024px) {
    display: flex;
  }
`

const SideNav = styled.div`
  @media screen and (max-width: 1023px) {
    position: fixed;
    top: 69px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    padding: 20px;
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.44) 0%,
        rgba(0, 0, 0, 0.58) 100%
      ),
      linear-gradient(0deg, #9f9f9f, #9f9f9f),
      linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
      linear-gradient(0deg, #000000, #000000),
      url(/static/media/HeroImage.668fb707.jpg), center;
    background-blend-mode: normal, color, overlay, saturation, normal;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: transparent;
    > a {
      border: none;
      background: transparent;
      text-align: left;
      font-size: 36px;
      padding: 10px 0;
      line-height: 1.2;
      &:hover {
        background: transparent !important;
        border: none !important;
      }
    }
  }
`

const LinkLogo = styled(Link)`
  @media screen and (min-width: 1024px) {
    display: flex;
    align-items: center;
  }
`

const LogoTitle = styled(Title)`
  color: #452562;
  @media screen and (min-width: 1024px) {
    color: #fff;
    margin-left: 8px;
  }
`

const LogoSvg = styled.div`
  @media screen and (max-width: 1023px) {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    display: block;
    height: 40px;
  }
  @media screen and (min-width: 1024px) {
    display: flex;
    background-color: #fff;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    svg {
      height: 32px;
      width: 20px;
    }
  }
`
